import { render } from "./SimSearchSection.vue?vue&type=template&id=c0b5807a"
import script from "./SimSearchSection.vue?vue&type=script&lang=js"
export * from "./SimSearchSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__